import axios from 'axios'

export class RequestConvoTips {
	static list = async () => {
		const res = await axios.get(`/admin/convo-tips`)
		return res.data
	}
	static create = async (formData) => {
		const res = await axios.post(`/admin/convo-tips`, formData)
		return res.data
	}
	static update = async (id, formData) => {
		const res = await axios.post(`/admin/convo-tips/${id}`, formData)
		return res.data
	}
	static delete = async (id) => {
		const res = await axios.post(`/admin/convo-tips/delete/${id}`)
		return res.data
	}
}